// hooks/useInitializeSocket.js
import { useMemo } from 'react';
import io from 'socket.io-client';

const useInitializeSocket = () => {
  const socket = useMemo(() => {
    return io(process.env.REACT_APP_SOCKET_URL, {
      path: '/socket.io',
      transports: ['websocket'],
      reconnectionAttempts: 3,
      reconnectionDelay: 3000,
      // secure: true, // Ensure the connection is secure
    });
  }, []);
  return socket;
};

export default useInitializeSocket;
